import { render, staticRenderFns } from "./InfoGraphicsBubbles.vue?vue&type=template&id=37436c35&scoped=true&"
import script from "./InfoGraphicsBubbles.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicsBubbles.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphicsBubbles.vue?vue&type=style&index=0&id=37436c35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37436c35",
  null
  
)

export default component.exports